import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getCurrentYear } from 'ps-components/lib/formatters';

import './styles.scss';

class SessionError extends Component {
  render() {
    const currentYear = getCurrentYear();
    const bodyTag = document.getElementsByTagName('body')[0];
    bodyTag.classList.add('is-error-page');

    return (
      <div className="session">
        <header className="session__header">
          <img src="/view/static/mp/images/logo-text.png" alt="MarketPay" className="session__logo" />
        </header>
        <div className="session__content">
          <p>{this.props.message}</p>
          <a
            className="pxl-btn pxl-btn-primary pxl-margin-top-large"
            onClick={() => {
              window.location.href = this.props.loginUrl;
            }}
          >
            Return to Login
          </a>
          <footer className="session__footer">
            &copy;{`2001-${currentYear} PayScale, Inc. All rights reserved. Patents Pending.`}
          </footer>
        </div>
      </div>
    );
  }
}

SessionError.propTypes = {
  loginUrl: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

export default SessionError;
